import errors from "./errors";
import categories from "./organizations/services-management/categories/categories";
import { Customer } from "./CRUDs/entities/Customer";
import { Section } from "./jobs-flow/Section";
import { Route } from "./Abstracts/Route";
import { TriggerFilter } from "./Common/Events/Events";
import { UnversalModal } from "./universal-modal/universal-modal";
import { reportRecordOpeningError } from "./Common/reportRecordOpeningError";

export default {
    customerRequest: (id = null) => {
        return new Customer(id);
    },
    init() {
        this.newCustomer();
        this.newCustomerMainPage();
        this.scroll();
        this.initCustomerOrders();
        this.organisationCustomerInfo();
        this.showCustomerMoreInfo();
        this.initPagination();
        this.queryParser();
        this.mobileMenu();
        if (!$('#customer-cab').length)
            this.newModal();
    },

    newCustomer() {
        $('.add-customer-modal-btn').each((index, element) => {
            $(element).on('click', () => {
                this.customerRequest().openModal('create');
                let type = 'create';
                //customerUploadFiles.customerDocumentsMaidModal('upload-customer_files', type);
            });
        });
    },
    newCustomerMainPage() {
        $('body').on('click', '#new_customer', function(e) {
            e.preventDefault();

            $.ajax({
                type: 'POST',
                url: '/new-customer',
                data: ({
                    name: $('#b_first_name').val(),
                    email: $('#b_email').val(),
                    phone: $('#b_phone').val(),
                    page_from: window.location.pathname,
                    lead_source: $('#lead_source').val(),
                }),
                success: function (response) {
                    $('.form-validation-errors').removeClass(['alert', 'alert-danger']);
                    $('.form-validation-errors').html('<div class="alert alert-success">'+ response.message +'</div>');
                    $('#register-form-modal').modal('show');
                    $('#register_form input#email').val($('#b_email').val());
                    $('#register_form input#phone').val($('#b_phone').val());
                },
                error: function (response) {
                    let err = response.responseJSON.errors;
                    errors.showAlerts(err);
                },
            });
        });
    },
    scroll() {
        $('body').on('click', '.scroll_try', function(e) {
            e.preventDefault();
            window.scrollTo( 0, $(document).height() - $('#footer').height() - $('#try').height() );
        });
    },
    initCustomerOrders() {
        $('body').on('click', '#customer-orders-modal tr', function (e) {
            let elem = $(this);
            let form_type = elem.data('form-type');
            let order_id = elem.data('order_id');
            let job_id = elem.data('job_id');
            let entity_type = elem.data('entity');
            if(order_id) {
                $.ajax({
                    type: 'GET',
                    url: '/services-management/categories/get-complete-form',
                    data: {form_type, order_id},
                    success: (response) => {
                        $('#customer-orders-modal').modal('hide');
                        $('#form-container').html(response);
                        categories.completeFormCategoryChange();
                        categories.serviceAttributeChangesValue();
                        categories.completeFormServiceChange();
                        categories.createOrderRequest();
                        //categories.serviceAttributeChangesValue();
                        $('#service-request-modal').modal('show');
                    }
                });
            }
            if (job_id && entity_type) {
                $.ajax({
                    type: 'GET',
                    url: `/jobs-flow/customer-job`,
                    data: {form_type, job_id, entity_type},
                    success: (response) => {
                        new Promise((resolve)=>{
                            $('#customer-orders-modal').modal('hide');
                            setTimeout(() => {
                                resolve();
                            }, 200);
                        }).then(()=>{
                            $('#form-container').html(response);
                            $('#view-job-modal').modal('show');
                        })
                        //categories.serviceAttributeChangesValue();
                    }
                });
            }
        });

    },
    organisationCustomerInfo(){
        let _this = this;
        $('body').on('click', '.customer-info-button', (e) => {
            e.preventDefault();
            let $button = $(this);

            if (!$button.prop('disabled')) {
                let customerId = $(e.target).data('customer-id');

                if (!customerId)
                    return false;

                let customerReq = _this.customerRequest(customerId);
                $.ajax({
                    type: 'GET',
                    //url: '/customers/get-info/' + customerId,
                    url: `/customers/form?entity=customer&type=contact&id=${customerId}&form-request=true`,
                    success: (response) => {
                        $('#form-container').html(response);
                        $('#contact-customer-modal').modal('show');
                        $('#customer-info-edit-customer').click((e) => {
                            e.preventDefault();
                            customerReq.openModal('edit', { id: customerId });
                            //openModal('customer', 'edit');
                            /* autocompleteForms('edit-customer', {
                                id: customerId,
                            }); */
                        });
                    }
                });

                $button.prop('disabled', true);
            }

            setTimeout(function() {
                $button.prop('disabled', false);
            }, 1500);
        });
    },
    showCustomerMoreInfo(){
        $('#customer_table').on('click', '.show_more_btn', function(e) {
            e.preventDefault();
            let customer_id = $(this).parent().data('customer_id');
            console.log($(this));

            $('.customer-info-'+customer_id).toggleClass('d-none');
            if ($('.customer-info-'+customer_id).hasClass('d-none')) {
                $(this).find('.arrow').css({'transform': '', 'top' : '12px'});
                $(this).find('span').text('More');
            } else {
                $(this).find('.arrow').css({'transform': 'rotate(225deg)', 'top' : '15px'});
                $(this).find('span').text('Close');
            }
        });
    },
    initPagination(){
        if (window.location.pathname == "/customers") {
            const section = new Section('customers');
            section.show();
        }
    },

    queryParser() {
        const filterContainer = $('.filter');
        const routes = [
            {
                location: '/customers',
                processedParams: {
                    'phone': (phone) => {
                        filterContainer.find('input').val(phone);
                        document.dispatchEvent(TriggerFilter);
                    },
                }
            }
        ]
        for (let routeOptions of routes) {
            Route.init(routeOptions);
        }
    },

    mobileMenu(){
        $('.customer-mobile-menu-btn').click(function() {
            console.log('click');

            if ($('.customer-management-modal').hasClass('opened')) {
                $('.customer-management-modal').removeClass('opened');
            } else {
                //$('.customer-management-modal').removeClass('opened');
                $('.customer-management-modal').addClass('opened');
            }
            let posX = $(this).position().left - ($('.customer-management-modal').width() + 10);
            let posY = $(this).position().top + ($('.customer-management-modal').height() + 30);
            $('.customer-management-modal').css({left: posX, top: posY});

        });
        $('body').off('click', '.customer-management-modal .close-elem')
        .on('click', '.customer-management-modal .close-elem', function() {
            $(this).parents('.customer-management-modal').removeClass('opened');
        });
    },

    newModal(){
        $('body').on('click','.open-new-modal', function(e) {
            const arr = ['INPUT', 'SELECT'];
            const positiveInteger = (value) => {
                const text = String(value ?? '').trim();
                return /^[1-9]\d*$/.test(text) ? Number(text) : null;
            };
            // Guard FIRST, THEN preventDefault. The preventDefault used to sit above this guard and
            // ran unconditionally, so it swallowed row-checkbox and in-cell <select> toggles app-wide.
            if ($(e.target).hasClass('red-checkbox')
                || $(e.target).closest('label.bb-check').length // .bb-check row checkbox: clicks land on the label/span, not the input
                || arr.includes($(e.target)[0].tagName)
                || $(e.target).hasClass('stafter-action')
                || $(e.target).parents('td').hasClass('stafter-action')) {
                return;
            }
            e.preventDefault();
            // Incident modals can occasionally leave a stale backdrop that blocks further clicks.
            if ($('.modal.show').length === 0 && $('.modal-backdrop').length) {
                $('.modal-backdrop').remove();
                $('body').removeClass('modal-open');
            }
            let step = $(this).attr('data-step') ?? $(this).data('step') ?? 'info';

            if (($(e.target)[0].tagName !== 'TD' && $(e.target).parents('td').hasClass('show-customer-projects')) || $(e.target).hasClass('show-customer-projects')){
                step = 'projects';
            }
            const rawCustomerId = $(this).attr('data-customer_id')
                ?? $(this).data('customer_id');
            const customer_id = positiveInteger(rawCustomerId);
            if (!customer_id) {
                reportRecordOpeningError('This customer has no valid organization ID.');
                return;
            }
            const internal_step = $(this).attr('data-internal_step') ?? $(this).data('internal_step') ?? null;
            const rawParentId = $(this).attr('data-parent') ?? $(this).data('parent') ?? null;
            const parent_id = rawParentId == null || rawParentId === '' ? null : positiveInteger(rawParentId);
            const rawParentLocalId = $(this).attr('data-parent-local-id') ?? null;
            const parentLocalId = rawParentLocalId == null || rawParentLocalId === ''
                ? null
                : positiveInteger(rawParentLocalId);
            const requiresParent = internal_step && ['projects', 'appointments', 'subscriptions', 'overview'].includes(step);
            if (requiresParent && (!parent_id || !parentLocalId)) {
                reportRecordOpeningError('This record has no valid organization ID.');
                return;
            }
            const rawEntityId = $(this).attr('data-id') ?? $(this).data('id') ?? null;
            const entity_id = ['info', 'appointments', 'subscriptions'].includes(step) || rawEntityId == null
                ? null
                : positiveInteger(rawEntityId);
            const rawEntityLocalId = $(this).attr('data-entity-local-id') ?? null;
            const entityLocalId = rawEntityLocalId == null || rawEntityLocalId === ''
                ? null
                : positiveInteger(rawEntityLocalId);
            if (rawEntityId != null && !['info', 'appointments', 'subscriptions'].includes(step)
                && (!entity_id || !entityLocalId)) {
                reportRecordOpeningError('This selected record has no valid organization ID.');
                return;
            }
            const modal = new UnversalModal(customer_id);
            modal.openModal(step, internal_step, parent_id, entity_id, {
                parentLocalId,
                entityLocalId,
            });
        });
    }
}
